import { PATH_CUSTOMER, PATH_CUSTOMER_REGISTER, PATH_LOGISTIC } from './paths';
import React, { lazy } from 'react';
import { Redirect } from 'react-router-dom';
import AuthProtect from 'src/components/Auth/AuthProtect';

import AuthProtectNotifications from 'src/components/Auth/AuthProtectNotifications/AuthProtectNotifications';
import AuthProtectCompanyProfile from 'src/components/Auth/AuthProtectCompanyProfile/AuthProtectCompanyProfile';
import AuthProtectCompanyProfileView from 'src/components/Auth/AuthProtectCompanyProfile/AuthProtectCompanyProfileView';
import AuthProtectCompanyProfileEdit from 'src/components/Auth/AuthProtectCompanyProfile/AuthProtectCompanyProfileEdit';
import AuthProtectCompanyProfileAdd from 'src/components/Auth/AuthProtectCompanyProfile/AuthProtectCompanyProfileAdd';
import AuthProtectOffers from 'src/components/Auth/AuthProtectOffers/AuthProtectOffers';
import AuthProtectOffersView from 'src/components/Auth/AuthProtectOffers/AuthProtectOffersView';
import AuthProtectOffersAdd from 'src/components/Auth/AuthProtectOffers/AuthProtectOffersAdd';
import AuthProtectClosedOffers from 'src/components/Auth/AuthProtectClosedOffers/AuthProtectClosedOffers';
import AuthProtectPreOrder from 'src/components/Auth/AuthProtectPreOrder/AuthProtectPreOrder';
import AuthProtectPreOrderView from 'src/components/Auth/AuthProtectPreOrder/AuthProtectPreOrderView';
import AuthProtectPreOrderEdit from 'src/components/Auth/AuthProtectPreOrder/AuthProtectPreOrderEdit';
import AuthProtectCatalogue from 'src/components/Auth/AuthProtectCatalogue/AuthProtectCatalogue';
import AuthProtectCatalogueView from 'src/components/Auth/AuthProtectCatalogue/AuthProtectCatalogueView';
import AuthProtectCatalogueAdd from 'src/components/Auth/AuthProtectCatalogue/AuthProtectCatalogueAdd';
import AuthProtectRestockOrder from 'src/components/Auth/AuthProtectRestockOrder/AuthProtectRestockOrder';
import AuthProtectOrder from 'src/components/Auth/AuthProtectOrder/AuthProtectOrder';
import AuthProtectPayment from 'src/components/Auth/AuthProtectPayment/AuthProtectPayment';
import AuthProtectPaymentUpdate from 'src/components/Auth/AuthProtectPaymentUpdate/AuthProtectPaymentUpdate';
import AuthProtectOrderIssues from 'src/components/Auth/AuthProtectOrderIssues/AuthProtectOrderIssues';
import AuthProtectOverpayment from 'src/components/Auth/AuthProtectOverpayment/AuthProtectOverpayment';
import AuthProtectConsignment from 'src/components/Auth/AuthProtectConsignment/AuthProtectConsignment';
import AuthProtectConsignmentStockReturnable from 'src/components/Auth/AuthProtectConsignment/AuthProtectConsignmentStockReturnable';
import AuthProtectConsignmentReport from 'src/components/Auth/AuthProtectConsignment/AuthProtectConsignmentReport';
import AuthProtectConsignmentSkuOrder from 'src/components/Auth/AuthProtectConsignment/AuthProtectConsignmentSkuOrder';
import AuthProtectStockProducts from 'src/components/Auth/AuthProtectConsignment/AuthProtectStockProducts';
import AuthProtectReport from 'src/components/Auth/AuthProtectConsignment/AuthProtectConsignment';
import AuthProtectStaff from 'src/components/Auth/AuthProtectStaff/AuthProtectStaff';
import AuthProtectStaffEdit from 'src/components/Auth/AuthProtectStaff/AuthProtectStaffEdit';
import AuthProtectStaffAdd from 'src/components/Auth/AuthProtectStaff/AuthProtectStaffAdd';
import AuthProtectDistributor from 'src/components/Auth/AuthProtectDistributor/AuthProtectDistributor';
import AuthProtectDistributorAdd from 'src/components/Auth/AuthProtectDistributor/AuthProtectDistributorAdd';


import DashboardCustomerLayout from 'src/layouts/DashboardCustomerLayout';

// ----------------------------------------------------------------------

const AppCustomerRoutes = {
  path: PATH_CUSTOMER.root,
  guard: AuthProtect,
  layout: DashboardCustomerLayout,
  routes: [
    // GENERAL
    // ----------------------------------------------------------------------

    // DASHBOARD
    {
      exact: true,
      path: PATH_CUSTOMER.general.dashboard,
      component: lazy(() => import('src/views/CustomerDashboardGroup/dashboard/DashboardAppView'))
    },

    // NOTIFICATIONS
    {
      exact: true,
      path: PATH_CUSTOMER.general.notifications,
      guard: AuthProtectNotifications,
      component: lazy(() => import('src/views/CustomerDashboardGroup/notifications/Notifications'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER.general.notificationDetail.view,
      guard: AuthProtectNotifications,
      component: lazy(() => import('src/views/CustomerDashboardGroup/notifications/detail/NotificationView'))
    },

    // OFFERS
    {
      exact: true, 
      path: PATH_CUSTOMER.general.offers,
      guard: AuthProtectOffers,
      component: lazy(() => import('src/views/CustomerDashboardGroup/offers/Offers'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER.general.offersDetail.view,
      guard: AuthProtectOffers,
      component: lazy(() => import('src/views/CustomerDashboardGroup/offers/offer-detail/OfferView2'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER.general.offersDetail.productDetail,
      guard: AuthProtectOffers,
      component: lazy(() => import('src/views/CustomerDashboardGroup/offers/offer-detail/ProductDetail'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER.general.offersDetail.offerBasket,
      guard: AuthProtectOffers,
      component: lazy(() => import('src/views/CustomerDashboardGroup/offers/offer-detail/OfferBasket'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER.general.offersDetail.offerSuccess,
      guard: AuthProtectOffers,
      component: lazy(() => import('src/views/CustomerDashboardGroup/offers/offer-detail/OfferSuccess'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER.general.offersDetail.manageRating,
      guard: AuthProtectOffers,
      component: lazy(() => import('src/views/CustomerDashboardGroup/offers/offer-detail/ManageRating'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER.general.offersDetail.manageRecommendedCartonQty,
      guard: AuthProtectOffers,
      component: lazy(() => import('src/views/CustomerDashboardGroup/offers/offer-detail/ManageRecommendedCartonQty'))
    },

    // PRE ORDER
    {
      exact: true,
      path: PATH_CUSTOMER.general.preOrder,
      guard: AuthProtectPreOrder,
      component: lazy(() => import('src/views/CustomerDashboardGroup/pre-order/PreOrder'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER.general.preOrderDetail.view,
      guard: AuthProtectPreOrder,
      component: lazy(() => import('src/views/CustomerDashboardGroup/pre-order/PreOrderView'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER.general.preOrderDetail.viewOrderDetail,
      guard: AuthProtectPreOrderEdit,
      component: lazy(() => import('src/views/CustomerDashboardGroup/pre-order/ViewOrderDetail'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER.general.preOrderDetail.staffPreOrderBreakdown,
      guard: AuthProtectPreOrder,
      component: lazy(() => import('src/views/CustomerDashboardGroup/pre-order/StaffPreOrderBreakdown'))
    },

    // CLOSED OFFERS
    {
      exact: true,
      path: PATH_CUSTOMER.general.closedOffers,
      guard: AuthProtectClosedOffers,
      component: lazy(() => import('src/views/CustomerDashboardGroup/closed-offers/ClosedOffers'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER.general.closedOffersDetail.view,
      guard: AuthProtectClosedOffers,
      component: lazy(() => import('src/views/CustomerDashboardGroup/closed-offers/closed-offers-detail/ClosedOfferView'))
    },

    // ALL ORDER
    {
      exact: true, 
      path: PATH_CUSTOMER.general.orderAll,
      component: lazy(() => import('src/views/CustomerDashboardGroup/order-all/OrderAll'))
    },
    // {
    //   exact: true,
    //   path: PATH_CUSTOMER.general.orderAllDetail.view,
    //   component: lazy(() => import('src/views/CustomerDashboardGroup/invoice/detail/InvoiceView2'))
    // },

    // ORDER
    {
      exact: true, 
      path: PATH_CUSTOMER.general.order,
      guard: AuthProtectOrder,
      component: lazy(() => import('src/views/CustomerDashboardGroup/invoice/Invoice'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER.general.orderDetail.view,
      guard: AuthProtectOrder,
      component: lazy(() => import('src/views/CustomerDashboardGroup/invoice/detail/InvoiceView2'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER.general.orderDetail.skuList,
      guard: AuthProtectOrder,
      component: lazy(() => import('src/components/InboundOrderComponent/SKUList'))
    },

    // CONSIGNMENT
    {
      exact: true,
      path: PATH_CUSTOMER.general.consignment,
      guard: AuthProtectConsignment,
      component: lazy(() => import('src/views/CustomerDashboardGroup/order-consignment/OrderConsignment'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER.general.consignmentDetail.view,
      guard: AuthProtectConsignment,
      component: lazy(() => import('src/views/CustomerDashboardGroup/order-consignment/details/OrderConsignmentView'))
    },

    // PAYMENT
    {
      exact: true,
      path: PATH_CUSTOMER.general.payment,
      guard: AuthProtectPayment,
      component: lazy(() => import('src/views/CustomerDashboardGroup/payment/Payment'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER.general.paymentDetail.view,
      guard: AuthProtectPayment,
      component: lazy(() => import('src/views/CustomerDashboardGroup/payment/PaymentView'))
    },

    // PAYMENT UPDATE
    {
      exact: true,
      path: PATH_CUSTOMER.general.paymentUpdate,
      guard: AuthProtectPaymentUpdate,
      component: lazy(() => import('src/views/CustomerDashboardGroup/payment-update/PaymentUpdate'))
    },

    // DISTRIBUTOR
    {
      exact: true,
      path: PATH_CUSTOMER.general.distributor,
      guard: AuthProtectDistributor,
      component: lazy(() => import('src/views/CustomerDashboardGroup/distributor/Distributor'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER.general.distributorView,
      guard: AuthProtectDistributor,
      component: lazy(() => import('src/views/CustomerDashboardGroup/distributor/DistributorView'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER.general.applyDistributor,
      guard: AuthProtectDistributorAdd,
      component: lazy(() => import('src/views/CustomerDashboardGroup/distributor/apply/ApplyDistributor'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER.general.distributorDetail.viewAllProducts,
      component: lazy(() => import('src/views/CustomerDashboardGroup/distributor/ViewAllProducts'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER.general.viewApplicationForm,
      component: lazy(() => import('src/views/CustomerDashboardGroup/distributor/view-application-detail/ViewForm'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER.general.editApplicationForm,
      component: lazy(() => import('src/views/CustomerDashboardGroup/distributor/edit-application-detail/EditForm'))
    },

    // REPORT
    {
      exact: true,
      path: PATH_CUSTOMER.general.report,
      guard: AuthProtectReport,
      component: lazy(() => import('src/views/CustomerDashboardGroup/report/Report'))
    },

    // PROFILE
    {
      exact: true,
      path: PATH_CUSTOMER.general.profile,
      component: lazy(() => import('src/views/CustomerDashboardGroup/profile/Profile'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER.general.editProfile,
      component: lazy(() => import('src/views/CustomerDashboardGroup/profile/EditProfile'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER.general.changeEmail,
      component: lazy(() => import('src/views/CustomerDashboardGroup/profile/ChangeEmail'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER.general.changePassword,
      component: lazy(() => import('src/views/CustomerDashboardGroup/profile/ChangePassword'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER.general.verificationCode,
      component: lazy(() => import('src/views/CustomerDashboardGroup/profile/VerificationCode'))
    },
    // RETAILER APPLICATION FORM
    {
      exact: true,
      path: PATH_CUSTOMER.general.retailerApplicationForm,
      guard: AuthProtectCompanyProfile,
      component: lazy(() => import('src/views/CustomerAppReviewGroup/retailer-application-form/RetailerApplicationForm'))
    },
    // EDIT RETAILER APPLICATION FORM FOR APPROVED STATUS
    {
      exact: true,
      path: PATH_CUSTOMER.general.editRetailerApplicationForm.form001,
      guard: AuthProtectCompanyProfileEdit,
      component: lazy(() => import('src/views/CustomerDashboardGroup/edit-retailer-application-form/Form001'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER.general.editRetailerApplicationForm.form002,
      guard: AuthProtectCompanyProfileEdit,
      component: lazy(() => import('src/views/CustomerDashboardGroup/edit-retailer-application-form/Form002'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER.general.editRetailerApplicationForm.form003,
      guard: AuthProtectCompanyProfileEdit,
      component: lazy(() => import('src/views/CustomerDashboardGroup/edit-retailer-application-form/Form003'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER.general.editRetailerApplicationForm.form004,
      guard: AuthProtectCompanyProfileEdit,
      component: lazy(() => import('src/views/CustomerDashboardGroup/edit-retailer-application-form/Form004'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER.general.editRetailerApplicationForm.form005,
      guard: AuthProtectCompanyProfileEdit,
      component: lazy(() => import('src/views/CustomerDashboardGroup/edit-retailer-application-form/Form005'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER.general.editRetailerApplicationForm.formSummary,
      guard: AuthProtectCompanyProfileEdit,
      component: lazy(() => import('src/views/CustomerDashboardGroup/edit-retailer-application-form/FormSummary'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER.general.editRetailerApplicationForm.formAgreement,
      guard: AuthProtectCompanyProfileEdit,
      component: lazy(() => import('src/views/CustomerDashboardGroup/edit-retailer-application-form/FormAgreementTermDistributor'))
    },

    // CONSIGNMENT REPORT
    {
      exact: true,
      path: PATH_CUSTOMER.general.consignmentReport,
      guard: AuthProtectConsignmentReport,
      component: lazy(() => import('src/views/CustomerDashboardGroup/consignment-report/ConsignmentReport'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER.general.addConsignmentReport.sale,
      guard: AuthProtectConsignmentReport,
      component: lazy(() => import('src/views/CustomerDashboardGroup/consignment-report/new/AddConsignmentSale'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER.general.addConsignmentReport.addProduct,
      guard: AuthProtectConsignmentReport,
      component: lazy(() => import('src/views/CustomerDashboardGroup/consignment-report/new/ConsignmentAddProduct'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER.general.consignmentReportDetail.view,
      guard: AuthProtectConsignmentReport,
      component: lazy(() => import('src/views/CustomerDashboardGroup/consignment-report/details/ConsignmentReportView'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER.general.addConsignmentReport.auditStock,
      guard: AuthProtectConsignmentReport,
      component: lazy(() => import('src/views/CustomerDashboardGroup/consignment-report/new/AddConsignmentAudit'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER.general.addConsignmentReport.addProductForAudit,
      guard: AuthProtectConsignmentReport,
      component: lazy(() => import('src/views/CustomerDashboardGroup/consignment-report/new/audit-stock/ConsignmentAddProduct'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER.general.editConsignmentReport.sale,
      guard: AuthProtectConsignmentReport,
      component: lazy(() => import('src/views/CustomerDashboardGroup/consignment-report/new/AddConsignmentSale'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER.general.editConsignmentReport.auditStock,
      guard: AuthProtectConsignmentReport,
      component: lazy(() => import('src/views/CustomerDashboardGroup/consignment-report/new/AddConsignmentAudit'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER.general.editConsignmentReport.addProduct,
      guard: AuthProtectConsignmentReport,
      component: lazy(() => import('src/views/CustomerDashboardGroup/consignment-report/new/ConsignmentAddProduct'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER.general.editConsignmentReport.addProductForAudit,
      guard: AuthProtectConsignmentReport,
      component: lazy(() => import('src/views/CustomerDashboardGroup/consignment-report/new/audit-stock/ConsignmentAddProduct'))
    },

    // CONSIGNMENT STOCK RETURNABLE
    {
      exact: true,
      path: PATH_CUSTOMER.general.consignmentStockReturnable,
      guard: AuthProtectConsignmentStockReturnable,
      component: lazy(() => import('src/views/CustomerDashboardGroup/consignment-stock-returnable/ConsignmentStockReturnable'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER.general.consignmentStockReturnableDetail.view,
      guard: AuthProtectConsignmentStockReturnable,
      component: lazy(() => import('src/views/CustomerDashboardGroup/consignment-stock-returnable/details/ConsignmentStockReturnableView'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER.general.addConsignmentStockReturnable.new,
      guard: AuthProtectConsignmentStockReturnable,
      component: lazy(() => import('src/views/CustomerDashboardGroup/consignment-stock-returnable/new/AddConsignmentStockReturnable'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER.general.addConsignmentStockReturnable.addProduct,
      guard: AuthProtectConsignmentStockReturnable,
      component: lazy(() => import('src/views/CustomerDashboardGroup/consignment-stock-returnable/new/ConsignmentAddProduct'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER.general.consignmentStockReturnableDetail.edit,
      guard: AuthProtectConsignmentStockReturnable,
      component: lazy(() => import('src/views/CustomerDashboardGroup/consignment-stock-returnable/details/ConsignmentStockReturnableEdit'))
    },

    // COMPANY ACCOUNT
    {
      exact: true,
      path: PATH_CUSTOMER.general.companyAccount,
      component: lazy(() => import('src/views/CustomerDashboardGroup/company-account/CompanyAccount'))
    },
    // STOCK PRODUCTS
    {
      exact: true,
      path: PATH_CUSTOMER.general.stockProducts,
      guard: AuthProtectStockProducts,
      component: lazy(() => import('src/views/CustomerDashboardGroup/stock-products/StockProducts'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER.general.stockProductsDetail.view,
      guard: AuthProtectStockProducts,
      component: lazy(() => import('src/views/CustomerDashboardGroup/stock-products/StockProductsView'))
    },

    // CONSIGNMENT SKU ORDER
    {
      exact: true,
      path: PATH_CUSTOMER.general.consignmentSkuOrder,
      guard: AuthProtectConsignmentSkuOrder,
      component: lazy(() => import('src/views/CustomerDashboardGroup/consignment-sku-order/ConsignmentSkuOrder'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER.general.consignmentSkuOrderDetail.view,
      guard: AuthProtectConsignmentSkuOrder,
      component: lazy(() => import('src/views/CustomerDashboardGroup/consignment-sku-order/detail/ConsignmentSkuOrderView'))
    },

    // STAFF
    {
      exact: true,
      path: PATH_CUSTOMER.general.staff,
      guard: AuthProtectStaff,
      component: lazy(() => import('src/views/CustomerDashboardGroup/staff/Staff'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER.general.addStaff,
      guard: AuthProtectStaffAdd,
      component: lazy(() => import('src/views/CustomerDashboardGroup/staff/new/AddStaff'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER.general.staffDetail.view,
      guard: AuthProtectStaff,
      component: lazy(() => import('src/views/CustomerDashboardGroup/staff/details/StaffView'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER.general.staffDetail.edit,
      guard: AuthProtectStaffEdit,
      component: lazy(() => import('src/views/CustomerDashboardGroup/staff/details/StaffEdit'))
    },

    // STAFF PRE-ORDER
    {
      exact: true,
      path: PATH_CUSTOMER.general.staffPreOrder,
      component: lazy(() => import('src/views/CustomerDashboardGroup/staff-preorder/StaffPreOrder'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER.general.staffPreOrderDetail.view,
      component: lazy(() => import('src/views/CustomerDashboardGroup/staff-preorder/StaffPreOrderView'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER.general.staffPreOrderDetail.generatePreOrder,
      component: lazy(() => import('src/views/CustomerDashboardGroup/staff-preorder/GeneratePreOrder'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER.general.staffPreOrderDetail.edit,
      component: lazy(() => import('src/views/CustomerDashboardGroup/staff-preorder/StaffPreOrderEdit'))
    },

    // ORDER ISSUE
    {
      exact: true,
      path: PATH_CUSTOMER.general.addOrderIssue,
      guard: AuthProtectOrderIssues,
      component: lazy(() => import('src/views/CustomerDashboardGroup/order-issue/AddOrderIssue'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER.general.orderIssues,
      guard: AuthProtectOrderIssues,
      component: lazy(() => import('src/views/CustomerDashboardGroup/order-issue/OrderIssues'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER.general.orderIssuesDetail.view,
      guard: AuthProtectOrderIssues,
      component: lazy(() => import('src/views/CustomerDashboardGroup/order-issue/details/OrderIssueView'))
    },
    
    // OVERPAYMENT
    {
      exact: true,
      path: PATH_CUSTOMER.general.overpayment,
      guard: AuthProtectOverpayment,
      component: lazy(() => import('src/views/CustomerDashboardGroup/credit-note/CreditNote'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER.general.overpaymentDetail.view,
      guard: AuthProtectOverpayment,
      component: lazy(() => import('src/views/CustomerDashboardGroup/credit-note/detail/CreditNoteView'))
    },

    // CATALOGUE
    {
      exact: true,
      path: PATH_CUSTOMER.general.catalogueDetail.view,
      guard: AuthProtectCatalogue,
      component: lazy(() => import('src/views/CustomerDashboardGroup/catalogue/Catalogue'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER.general.catalogueDetail.listProduct,
      guard: AuthProtectCatalogue,
      component: lazy(() => import('src/views/CustomerDashboardGroup/catalogue/list-product/ListProduct'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER.general.catalogueDetail.productDetail,
      guard: AuthProtectCatalogue,
      component: lazy(() => import('src/views/CustomerDashboardGroup/catalogue/product/Product'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER.general.cart.root,
      guard: AuthProtectCatalogue,
      component: lazy(() => import('src/views/CustomerDashboardGroup/catalogue/cart/Cart'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER.general.cart.confirmation,
      guard: AuthProtectCatalogue,
      component: lazy(() => import('src/views/CustomerDashboardGroup/catalogue/cart/Confirmation'))
    },

    // RESTOCK ORDER
    {
      exact: true, 
      path: PATH_CUSTOMER.general.restockOrder,
      guard: AuthProtectRestockOrder,
      component: lazy(() => import('src/views/CustomerDashboardGroup/restock-order/RestockOrder'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER.general.restockOrderDetail.view,
      guard: AuthProtectRestockOrder,
      component: lazy(() => import('src/views/CustomerDashboardGroup/restock-order/RestockOrderView'))
    },
  ]
}

export default AppCustomerRoutes